export const queryParamTermSelector = ({
  queryParamTerm
}) => queryParamTerm;